import { useSelector } from 'react-redux';
import { authProfile } from 'redux/auth/selectors';
import { collectionsEnabledFor } from 'constants/flags';

// Si el usuario logueado ve colectas en rutas (flag más OPL habilitado).
const useCollectionsEnabled = () => {
  const profile = useSelector(authProfile);
  return collectionsEnabledFor(profile?.logisticOperatorID);
};

export default useCollectionsEnabled;
